export default {
  header: {
    title: 'Cumpără card cadou',
  },
  items: {
    gift_card: {
      label: 'Card cadou',
      title: 'Selectați suma dorită',
      description: 'Adăugați cardul cadou cu cantitatea dorită în coș',
    },
    expiration: {
      label: 'Valabil 3 ani',
      title: 'Bucurați-vă de dar!',
      description: 'Destinatarul poate folosi voucherul flexibil timp de 3 ani.',
    },
    delivery: {
      label: 'Livrare imediată ca PDF prin e-mail',
      title: 'Livrare instantanee ca PDF prin e-mail',
      description: 'După plata securizată cu cardul de credit, PayPal sau giropay, veți primi voucherul imediat.',
    },
  },
  form: {
    value: {
      title: 'Alegeți suma cardului cadou',
      custom: {
        label: 'Personalizat',
        placeholder: 'Introduceți suma',
      },
    },
    quantity: {
      title: 'Cantitate',
    },
    email: {
      title: 'Care este adresa dvs. de e-mail pentru a vă trimite cardul cadou?',
      placeholder: 'Adresa dvs. de e-mail',
    },
  },
  confirmation: {
    title: {
      title: 'Creați cardul cadou?',
      subtitle_one: 'Doriți să creați 1 card cadou pentru {{value}}?',
      subtitle_few: 'Vrei să creezi {{count}} carduri cadou de {{value}}?',
      subtitle_other: 'Doriți să creați {{count}} carduri cadou pentru {{value}}?',
    },
    description: {
      total: 'Total:',
      email: 'E-mail:',
      quantity: 'Cantitate',
      amount: 'Sumă',
    },
    footer: {
      cancel: 'Anulare',
      confirm: 'Confirmare',
    },
  },
  buttons: {
    create: 'Creare',
  },
  toasts: {
    error: 'Crearea cardului cadou a eșuat.',
    success: 'Card cadou creat cu succes.',
  },
};
